import React from "react";
import PageContent from "../components/PageContent";
import { PageType } from "../../../enums/page-type.enum";

const PrivacyPolicy = () => {
  return <PageContent page={PageType.PRIVACY_POLICY} title="Privacy Policy" />;
};

export default PrivacyPolicy;
